export const brands = ['格力','美的','海信','TCL','方太','老板','创维','康佳','西门子','史密斯','小天鹅','三洋','能率','林内','松下','长虹','华帝','小米','乐视','酷开','博世','美菱','奥克斯','其他'];
export const categories = ['冰箱','洗衣机','冷柜','空调','彩电','厨电','热水器','净水机','洗碗机','小家电','其他']
export const completeProductCategory = [
    {
        title:'全品类',
        desc:'冰箱，洗衣机，空调，电视，热水器，厨电类'
    },
    {
        title:'冰箱',
        desc:'冰箱、冰柜(不包括酒柜、商用展示柜)'
    },
    {
        title:'洗衣机',
        desc:'洗衣机(包括滚筒洗衣机、波轮洗衣机、洗烘一体机，单独烘衣机)'
    },
    {
        title:'空调',
        desc:'空调(包括家用空调型号、商用空调型号的多联机，新风系统、空气能空调，不包括风冷机组、水冷机组、地温中央空调或集中供热供冷机组)	'
    },
    {
        title:'电视',
        desc:'电视(仅包含液晶电视，不包括多功能会议电视、激光电视、投影仪等)'
    },
    {
        title:'热水器',
        desc:'包括电热(限储水式)、燃气、太阳能热水器，不包括厨房用即热性热水器'
    },
    {
        title:'厨电类',
        desc:'油烟机、燃气灶、洗碗机、智能马桶盖'
    }
]

export const applicantUploadFileMap = {
    // 货车雇主责任险按人
    'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE':[
        {
            label:'行驶证挂靠协议<br>（多份用压缩文件）',
            name:'行驶证挂靠协议',
            key:'affiliationAgreement',
            type:'file',
            identityType:'PERSON',// 申请人类型 PERSON人，COMPANY公司
            note:'上传的行驶证挂靠协议必须是申请人本人车辆的挂靠协议。'
        }
    ],
    // 货车雇主责任险按车
    'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_TRUCK':[
        {
            label:'行驶证挂靠协议<br>（多份用压缩文件）',
            name:'行驶证挂靠协议',
            key:'affiliationAgreement',
            type:'file',
            identityType:'PERSON',// 申请人类型 PERSON人，COMPANY公司
            note:'上传的行驶证挂靠协议必须是申请人本人车辆的挂靠协议。'
        }
    ]
    
}



// WEBPACK FOOTER //
// ./src/pages/haierProduct/common/dictionary.js